import { Box, Grid, Typography, Divider } from '@mui/material';
import { insightStaticSummary, defaultSummary } from './utils';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const SummaryDetails = ({
  enableDarkTheme,
  data,
}: {
  enableDarkTheme: boolean;
  data: Record<string, string>;
}) => {
  const { t } = useTranslation();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const rawIssue = data?.issue ?? '';
  const issue = rawIssue.includes('Clogged Air Filter')
    ? 'Engine Air Filter Clogging'
    : rawIssue;
  // @ts-expect-error ignore, const defined
  let display: Record<string, string> = insightStaticSummary[issue];
  if (!display) {
    display = defaultSummary;
  }

  const recommendedActionText = display.recommendedAction ?? '';
  const recommendedActionLines = recommendedActionText
    .split('<br>')
    .map((s) => s.trim())
    .filter(Boolean);
  return (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Box
        sx={{
          padding: '20px 10px 20px 10px',
          backgroundColor: palette.boxBackground,
          borderRadius: '5px',
          border: `1px solid rgba(255, 255, 255, 0.15)`,
          minHeight: '500px',
          maxHeight: '500px',
          color: enableDarkTheme ? '#fff' : '#000',
        }}
      >
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: '700',
          }}
        >
          Summary
        </Typography>

        <Typography
          sx={{
            marginTop: '10px',
            fontSize: '12px',
            fontWeight: '700',
          }}
        >
          {t('issue')}
        </Typography>
        <Typography
          sx={{
            fontSize: '12px',
            marginTop: '5px',
          }}
        >
          {display.issue}
        </Typography>

        <Typography
          sx={{
            marginTop: '10px',
            fontSize: '12px',
            fontWeight: '700',
          }}
        >
          {t('subsystem')}
        </Typography>
        <Typography
          sx={{
            fontSize: '12px',
            marginTop: '5px',
          }}
        >
          {display.subsystem}
        </Typography>
        <Typography
          sx={{
            marginTop: '20px',
            fontSize: '12px',
            fontWeight: '700',
            marginBottom: '5px',
          }}
        >
          {t('causes')}
        </Typography>
        {display.causes.split('<br>').map((line: string, index: number) => (
          <Typography
            key={index}
            sx={{
              fontSize: '12px',
              marginBottom:
                index < display.causes.split('<br>').length - 1 ? '4px' : 0,
            }}
          >
            {line}
          </Typography>
        ))}

        <Typography
          sx={{
            marginTop: '20px',
            fontSize: '12px',
            fontWeight: '700',
            marginBottom: '5px',
          }}
        >
          {t('impact')}
        </Typography>
        {display.impact.split('<br>').map((line: string, index: number) => (
          <Typography
            key={index}
            sx={{
              fontSize: '12px',
              marginBottom:
                index < display.impact.split('<br>').length - 1 ? '4px' : 0,
            }}
          >
            {line}
          </Typography>
        ))}

        <Divider
          sx={{
            backgroundColor: 'rgba(255,255,255,0.2)',
            marginTop: '20px',
            marginBottom: '10px',
          }}
        />

        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: '700',
            marginBottom: '20px',
          }}
        >
          {t('recommended_actions')}
        </Typography>

        {recommendedActionLines.length ? (
          recommendedActionLines.map((line: string, index: number) => (
            <Typography
              key={index}
              sx={{
                fontSize: '12px',
                marginBottom:
                  index < recommendedActionLines.length - 1 ? '4px' : 0,
              }}
            >
              {line}
            </Typography>
          ))
        ) : (
          <Typography sx={{ fontSize: '12px', marginBottom: 0 }}>
            N/A
          </Typography>
        )}
      </Box>
    </Grid>
  );
};
